import React, { Component } from "react";
//import { Bar, Line } from "react-chartjs-2";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
//import { CustomTooltips } from "@coreui/coreui-plugin-chartjs-custom-tooltips";
//import { getStyle } from "@coreui/coreui/dist/js/coreui-utilities";
import { configuration } from "../../appConfig";
import Axios from "axios";
//import FathTable from "./FathTable";
import { connect } from "react-redux";
// const Widget03 = lazy(() => import("../../views/Widgets/Widget03"));

// const brandPrimary = getStyle("--primary");
// const brandSuccess = getStyle("--success");
// const brandInfo = getStyle("--info");
// const brandWarning = getStyle("--warning");
// const brandDanger = getStyle("--danger");

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class DAT extends Component {
  state = {
    orders: [],
    color: "-",
    startScan: false,
    count: 0,
    words: {},
    lang: "En",
    ditInfo: [],
  };
  componentDidMount() {
    this.ditInfo();
    this.startTimer();
    this.checkServerscanStatus();
    //this.setState({lang:localStorage.getItem("lang")})
    this.getLang();
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  updateServer = () => {
    const partnerId = localStorage.getItem("partnerId");
    Axios.post(
      "http://driveandscan.de/scancommand/index.php?pid=" +
        partnerId +
        "&startScan=1",
      {}
    )
      .then((res) => {
        this.setState({ startScan: true, count: 0 });
        alert("Scan Initiated");
      })
      .catch((err) => {
      });
  };
  createLocalFile = (msg) => {
    const url = "http://localhost:9001/api/v1/startScan";
    const payload = { color: this.state.color, msg: msg };
    Axios.post(url, payload)
      .then((res) => {
        alert("Scan Started..");
        // this.setState({startScan:true,count:0})
        //this.updateServer();
      })
      .catch((err) => {
        //this.updateServer();
        alert("Error! Local Server Not Started..");
      });
  };
  checkServerscanStatus = () => {
    setInterval(() => {
      if (this.state.startScan) {
        const partnerId = localStorage.getItem("partnerId");
        Axios.post(
          "http://driveandscan.de/scancommand/index.php?pid=" +
            partnerId +
            "&getStatus=1",
          {}
        ).then((res) => {
          if (res.data.status === "0") {
            this.setState({ startScan: false });
          }
          //
          //alert("Scan Initiated");
        });
      }
      // this.setState({ count });
    }, 1000);
  };
  startTimer = () => {
    let count = this.state.count;

    setInterval(() => {
      if (this.state.startScan) {
        count = count + 1;
      }
      this.setState({ count });
    }, 10000);
  };
  ditInfo = async () => {
    const partnerId = localStorage.getItem("partnerId");
    if (partnerId) {
      //  const url =configuration.getOrders;
      const url = configuration.getDitInfo;
      const response = await Axios.get(url + "?partnerId=" + partnerId).catch(
        (err) => {
        }
      );

      if (response && response.data && response.data.length > 0) {
        const vinAvg = response.data.length && response.data;
        this.setState({ orders: vinAvg });
      }
    } else {
      this.props.history.push("/login");
    }
  };

  loading = () => (
    <div className="animated fadeIn pt-1 text-center">Loading...</div>
  );
  static getDerivedStateFromProps(nextProps, prevState) {
    //alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      //  alert(prevState.lang)
      return { lang: nextProps.lang };
    } else return null;
  }

  getPartDetails = async (rowArray, vin) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    // const vin = localStorage.getItem("selectedFile");

    for (let i = 0; i < rowArray.length; i++) {
      // if (rowArray[i].Amount) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i];
      //promises.push(url);
      promises.push(Axios.get(url));
      // }
    }

    const arrRes = await Axios.all(promises);
    //const res = await Axios.get("http://driveandscan.de/api_v2/GetPartDetails.php?vin=279639&partnerId=001-sandip&part="+row.part)

    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");
      val.pop();
      var gtt = [];
      if (val.length) {
        gtt = val.map((r) => {
          let val2 = r.split(" ")[3];
          return parseInt(val2);
        });
      }

      return {
        name: result.data.part,
        dents: [...gtt],
        // lt25: ltcount,
        images: [
          `http://driveandscan.de/scanImages/${partnerId}/${vin}/Report_${result.data.part}_1.jpg`,
        ],
        //ltunit: calculatePrice(24, ltcount),
        // gtunit: calculatePrice(26, gtcount),
      };
    });
    //   this.setState({ swissTable: ltgtdata });
    let nndata = { panels: ltgtdata };
    //return 5
    return { panels: ltgtdata, vin };
  };

  sendToPdR = async (row) => {
    const confirm = window.confirm("Do you want to send data to PDR ?");
    const parts = [
      "Hood",
      "LeftFrontFender",
      "RightFrontFender",
      "LeftFrontDoor",
      "LeftBackDoor",
      "RightFrontDoor",
      "RightBackDoor",
      "LeftBackFender",
      "RightBackFender",
      "Trunk",
      "LeftRoofFrame",
      "RightRoofFrame",
      "Roof",
    ];
    const { vin } = row;
    const panels = await this.getPartDetails(parts, vin);
    const url =
      "https://pdrmobile-prod-functions.azurewebsites.net/api/drive-n-scan";
    const data = {
      vin: row.vin,
      panels: panels.panels,
    };
    if (confirm) {
      const res = await Axios.post(url, data, {
        headers: {
          "x-functions-key":
            "F3I5lQOeO6QckaaOYnBqGDYPqpayo8B9rUTFWjHQPKDc3geRlQOF/g==",
        },
      }).catch((err) => console.log(err));
    }
  };
  render() {
    // alert();
    const columns = [
      {
        Header: "Sn.",
        id: "row",
        maxWidth: 150,
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "VIN Number",
        filterable: true,
        maxWidth: 400,
        accessor: "vin",

        Cell: (props) => (
          <span
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
              localStorage.setItem("userSession", "");

              this.props.history.push("/customer-info");
            }}
          >
            {props.value}
          </span>
        ),
      },
      {
        Header: "Claim Number",
        filterable: true,
        maxWidth: 200,
        accessor: "claimNo",
        Cell: (props) => (
          <span
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
              this.props.history.push("/customerInfo");
            }}
          >
            {props.value}
          </span>
        ),
      },

      {
        Header: (props) => <span>DAT Details</span>, // Custom header components!
        maxWidth: 400,
        accessor: "claimNo",
        Cell: (props) => {
          const lnk = `https://www.dat.de/myClaim/inbox.jsp?rnd=67644#claim?subView=vro_calculation&claim=${props.value}&fullscreen=true`;
          const lnk1 = `https://www.dat.de/myClaim/json/security/Login?signature=9DC08C58C84722C5151DF153E8C598B844E53CCC479AFD9C4389AD367CADDBD7&customerNumber=1333360&login=kasadhru&redirect=inbox.jsp#claim?subView=vro_calculation&claim=8677505&fullscreen=true`;

          return (
            <a target="_blank" href={lnk1} {...this.props}>
              {" "}
              Show Details In DAT
            </a>
          );
        },
      },
    ];
    const tableProps = {
      defaultPageSize: 5,
      filterable: false,
      defaultSortDesc: false,
      showPagination: true,
      showPageSizeOptions: false,
    };
    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
        : true;
    }

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="6" lg="3">
            <Card className="text-white bg-info">
              <CardBody className="pb-0">
                {/* <ButtonGroup className="float-right">
                  <ButtonDropdown id='card1' isOpen={this.state.card1} toggle={() => { this.setState({ card1: !this.state.card1 }); }}>
                    <DropdownToggle caret className="p-0" color="transparent">
                      <i className="icon-settings"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem>Action</DropdownItem>
                      <DropdownItem>Another action</DropdownItem>
                      <DropdownItem disabled>Disabled action</DropdownItem>
                      <DropdownItem>Something else here</DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </ButtonGroup> */}
                <div className="text-value">{this.state.orders.length}</div>
                <div>{this.lang("Total No of Scans")}</div>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white bg-primary">
              <CardBody className="pb-0">
                <div className="text-value">3000</div>
                <div>{this.lang("Your Scan Limit")}</div>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white bg-warning">
              <CardBody className="pb-0">
                <div className="text-value">{this.state.count} sec</div>
                <div>{this.lang("Scan Time")}</div>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white bg-danger">
              <CardBody className="pb-0">
                <div className="text-value">
                  {localStorage.getItem("partnerId")}
                </div>
                <div>{this.lang("Your Partner Id")}</div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card>
              <CardHeader>DAT Claims</CardHeader>
              <CardBody>
                <ReactTable
                  id="t12"
                  style={{ textAlign: "center" }}
                  data={this.state.orders}
                  columns={columns}
                  {...tableProps}
                  minRows={20}
                  defaultPageSize={20}
                  defaultFilterMethod={(filter, row) =>
                    filterCaseInsensitive(filter, row)
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(DAT);
